import { useEffect } from 'react';
import configJson from   '../../Config.json';

const GoogleAnalytics = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-L3KZWBZGNF';
    script.nonce='GoCMSWebNAUSGHDV'
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', configJson.googleAnalytics);
    };

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return <></>;
};

export default GoogleAnalytics;
